module.exports = __webpack_public_path__ + "static/img/jinritemai.1a3d9fb4.svg";